import { render, staticRenderFns } from "./elecItem.vue?vue&type=template&id=bb4bdbbc&scoped=true&"
import script from "./elecItem.vue?vue&type=script&lang=js&"
export * from "./elecItem.vue?vue&type=script&lang=js&"
import style0 from "./elecItem.vue?vue&type=style&index=0&id=bb4bdbbc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb4bdbbc",
  null
  
)

export default component.exports